import { styled, type Theme } from "@mui/material/styles";

import { FULL_APP_BAR_MIN_WIDTH } from "~/components/AppBar/AppBar.styles";
import * as SearchField from "~/components/UI/SearchField/SearchField.styles";
import { HEADER_SEARCH_WIDTH } from "~/feature/search/constants";
import type { SearchFieldVariant } from "~/feature/search/type";
import {
  borderColor,
  hoverColor,
  inkColor,
  mutedColor,
  paperColor,
} from "~/styles/redesignColors";

const belowFull = (theme: Theme) =>
  theme.breakpoints.down(FULL_APP_BAR_MIN_WIDTH);

interface IVariantProps {
  variant: SearchFieldVariant;
}

const variantOptions = {
  shouldForwardProp: (prop: PropertyKey) => prop !== "variant",
};

export const Search = styled(
  SearchField.Search,
  variantOptions
)<IVariantProps>(({ theme, variant }) =>
  variant === "toolbar"
    ? {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.75),
        height: 32,
        boxSizing: "border-box",
        padding: theme.spacing(0, 1.5),
        borderRadius: 999,
        borderColor: borderColor(theme),
        backgroundColor: paperColor(theme),

        "&:hover": {
          backgroundColor: hoverColor(theme),
        },
      }
    : {
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
        maxWidth: HEADER_SEARCH_WIDTH,

        [belowFull(theme)]: {
          marginLeft: 0,
          marginRight: 0,
        },
      }
);

export const SearchIconWrapper = styled(
  SearchField.SearchIconWrapper,
  variantOptions
)<IVariantProps>(({ theme, variant }) =>
  variant === "toolbar"
    ? {
        position: "static",
        height: "auto",
        padding: 0,
        color: mutedColor(theme),

        "& svg": {
          fontSize: 18,
        },
      }
    : {
        [belowFull(theme)]: {
          padding: theme.spacing(0, 1),
        },
      }
);

export const StyledInputBase = styled(
  SearchField.StyledInputBase,
  variantOptions
)<IVariantProps>(({ theme, variant }) =>
  variant === "toolbar"
    ? {
        flex: "1 1 auto",
        minWidth: 0,
        fontSize: 13,
        color: inkColor(theme),

        "& .MuiInputBase-input": {
          padding: 0,
          height: 30,
        },
      }
    : {
        [belowFull(theme)]: {
          "& .MuiInputBase-input": {
            paddingLeft: `calc(1em + ${theme.spacing(2)})`,
            paddingRight: `calc(1em + ${theme.spacing(1.5)})`,
          },
        },
      }
);

export const EndAdornmentWrapper = styled(
  SearchField.EndAdornmentWrapper,
  variantOptions
)<IVariantProps>(({ theme, variant }) =>
  variant === "toolbar"
    ? {
        position: "static",
        height: "auto",
        padding: 0,
        color: mutedColor(theme),
      }
    : {
        [belowFull(theme)]: {
          paddingRight: theme.spacing(1),
        },
      }
);
